import { useState } from 'react';

const EnterPriseDevelopment = () => {
    const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('');

  const toggleDropdown = () => setIsOpen(!isOpen);
  
  const handleItemClick = (value) => {
    setSelected(value);
    setIsOpen(false);
  };
  const data = [
    {
      type: 'Crop farming',
      description: 'Growing plants for food or sales',
      example: 'Maize, vegetables',
    },
    {
      type: 'Livestock farming',
      description: 'Rearing animals for meat, milk or eggs',
      example: 'cattle, poultry',
    },
    {
      type: 'Mixed farming',
      description: 'Combining both crop and livestock activities',
      example: 'Maize + Poultry',
    },
    {
      type: 'Niche specialized',
      description: 'High value or organic farming',
      example: 'Mushrooms, herbs',
    },
  ];
  const data1  = [
    {
      type: 'Seeds (tomatoes)',
      description: '1 kg',
      example: 'R 100',
      cost: 'R 100',

    },
    {
        type: 'Fertilizer',
        description: '2 kg',
        example: 'R 150',
        cost: 'R 150',
  
      },
    {
      type: 'Labour (monthly)',
      description: '2 workers',
      example: 'R 1000',
      cost: 'R 2000',

    },

  ];
  return (
    <div>
        <h1 className='md:text-[32px] font-bold text-[#03897B]'>ENTERPRISE DEVELOPMENT </h1>
        <div className='mx-auto text-center'>
        <h1 className='md:text-[36px] font-bold text-[#03897B] md:-mb-2'>TRAINING</h1>
        <h1 className='md:text-[32px] font-normal '>Training course materials</h1>
        </div>
        <div className="relative">
<div>
    <div className="relative w-full ">
      
      <div className="mt-2">
        <button
          onClick={toggleDropdown}
          className="block w-full text-[10px] md:text-[32px] text-[#03897B] font-bold  text-left flex  items-center space-x-5"
        >

          <span className='md:mb-4 md:mt-4'>       <h1 className='md:text-[32px] font-bold text-black inline'>COURSE 1:</h1>{selected || " ENTERPRISE DEVELOPMENT "}</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745233129/Expand_down_4_u8evgk.png"
            alt="dropdown icon"
            className={`w-2 h-2 md:w-6 md:h-6   transition-transform ${isOpen ? 'rotate-180' : ''}`}
          />
        </button>
        
        {isOpen && (
          <div className="absolute w-full mt-1 z-50 p-2 bg-white/90 rounded-lg shadow-lg">
            <div
              onClick={() => handleItemClick('Option 1')}
              className="cursor-pointer px-4 py-2 mt-1 hover:bg-gray-100 bg-gray-300 rounded-md"
            >
              Option 1
            </div>
            <div
              onClick={() => handleItemClick('Option 2')}
              className="cursor-pointer px-4 py-2 mt-1  hover:bg-gray-100 bg-gray-300 rounded-md"
            >
              Option 2
            </div>
            <div
              onClick={() => handleItemClick('Option 3')}
              className="cursor-pointer px-4 py-2 mt-1 hover:bg-gray-100 bg-gray-300 rounded-md"
            >
              Option 3
            </div>
            <div
              onClick={() => handleItemClick('Option 4')}
              className="cursor-pointer px-4 py-2 mt-1  hover:bg-gray-100 bg-gray-300 rounded-md"
            >
              Option 4
            </div>
            <div
              onClick={() => handleItemClick('Option 5')}
              className="cursor-pointer px-4 py-2 mt-1  hover:bg-gray-100 bg-gray-300 rounded-md"
            >
              Option 5
            </div>
          </div>
        )}
      </div>
      
    </div>
</div>
{/* Main Image with fade + scale animation */}
<img
  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745784257/image_57_cg8gsv.png"
  alt="App"
  className="w-full h-auto object-cover "
/>

{/* Play Icon */}
<img
  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
  alt="Play"
  className="absolute md:top-[45%] top-[40%] left-[52%] transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-[133px] md:h-[133px] z-20 cursor-pointer md:left-[50%]"
/>

{/* Bottom Overlay Content */}
<div className="absolute bottom-6 left-0 w-full px-4 md:px-6 z-10">
  <h1 className='md:text-[24px] text-white font-semibold text-[10px] tracking-wider'>
    TRAINING
  </h1>

  <div className="relative w-full h-[30px] md:h-[80px] flex items-center justify-between rounded-[10px] text-white border-t-[1px] md:border-t-[3px] border-white">
    <div className="flex flex-col">
      <p className="text-[8px] md:text-[24px] font-normal md:text-left">
        Training Farmers on Poultry <br /> Farming
      </p>
    </div>

    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745784544/image_1713_npu9h0.png"
      alt="QR"
      className="w-[25px] h-[25px] md:w-[60px] md:h-[70px] object-contain"
    />
  </div>
</div>

{/* Background Layer */}
<div className="absolute bottom-6 left-0 right-0 box bg-[#71451F] rounded-[10px] mix-blend-lighten  opacity-90 z-0 h-[30px] md:h-[80px] px-4 md:px-12" />
</div>
<div >
  <h3 className="text-[#03897B] font-bold md:mt-4 md:mb-6 text-[32px]  mb-2">COURSE MATERIAL</h3>

  <h2 className="font-bold text-[32px]">
    Farming Enterprise Training Course Material – Sample Module
  </h2>
  <p className="font-bold text-[32px] mb-6">
    Module Title: <span className="font-bold">Introduction to Farming as a Business</span>
  </p>

  <p className="font-bold  text-[32px]">Learning Objectives:</p>
  <p className="mb-2  text-[32px] ">By the end of this module, participants should be able to:</p>
  <ul className="list-disc list-inside  pl-4 text-[32px] space-y-1">
    <li>Understand the concept of farming as a business enterprise.</li>
    <li>Identify various types of farming enterprises.</li>
    <li>Develop a simple farm business plan.</li>
    <li>Understand basic farm record-keeping.</li>
  </ul>

  <h3 className="font-bold  text-[32px]  mb-2">Section 1: Understanding Farming as a Business</h3>

  <p className="font-bold mb-1  text-[32px] md:mt-8 " >1.1 Definition of a Farming Enterprise:</p>
  <p className="mb-8  text-[32px] ">
    A farming enterprise is an organized agricultural activity intended to generate income
    through the production of crops and/or livestock.
  </p>

  <p className="font-bold  text-[32px]  mb-1">1.2 Why View Farming as a Business?</p>
  <ul className="list-disc text-[32px] pl-6   list-inside mb-4 space-y-1">
    <li>Profit generation</li>
    <li>Improved efficiency</li>
    <li>Better decision-making</li>
    <li>Access to finance</li>
  </ul>

  <p className="font-bold mb-1  text-[32px] ">1.3 Types of Farming Enterprises:</p>
  {/* You can add content below this as needed */}
</div>
<div>
  {/* Header */}
  <div className="grid grid-cols-[1fr_2fr_1fr] gap-x-3 ">
    <div className="flex items-center bg-[#03897B] text-white font-bold text-[32px] h-[100px] rounded-t-lg px-6 ">Type</div>
    <div className="flex items-center bg-[#03897B] text-white font-bold text-[32px] h-[100px] rounded-t-lg px-6">Description</div>
    <div className="flex items-center bg-[#03897B] text-white font-bold text-[32px] h-[100px] rounded-t-lg px-6">Example</div>
  </div>

  {/* Data Rows */}
  <div className="space-y-4 mt-4">
    {data.map((item, index) => (
      <div
        key={index}
        className="grid grid-cols-[1fr_2fr_1fr] gap-x-3"
      >
        <div className="flex items-center bg-[#E7EBEB] text-black text-[32px] h-[100px] rounded-lg px-6">
          {item.type}
        </div>
        <div className="flex items-center bg-[#E7EBEB] text-black text-[32px] h-[100px] rounded-lg px-6">
          {item.description}
        </div>
        <div className="flex items-center bg-[#E7EBEB] text-black text-[32px] h-[100px] rounded-lg px-6">
          {item.example}
        </div>
      </div>
    ))}
  </div>
</div>
  <p className="font-bold  text-[32px] mt-6">Learning Objectives:</p>
  <p className="mb-2  text-[32px] ">By the end of this module, participants should be able to:</p>
  <ul className="list-disc list-inside  pl-4 text-[32px] space-y-1">
    <li>Understand the concept of farming as a business enterprise.</li>
    <li>Identify various types of farming enterprises.</li>
    <li>Develop a simple farm business plan.</li>
    <li>Understand basic farm record-keeping.</li>
  </ul>
  <div>
  {/* Header */}
  <div className="grid grid-cols-[2fr_1fr_1fr_1fr] gap-x-2 ">
    <div className="flex items-center bg-[#03897B] text-white font-bold text-[32px] h-[100px] rounded-t-lg px-6 ">Item</div>
    <div className="flex items-center bg-[#03897B] text-white font-bold text-[32px] h-[100px] rounded-t-lg px-6">Quantity</div>
    <div className="flex items-center bg-[#03897B] text-white font-bold text-[32px] h-[100px] rounded-t-lg px-6">Unit cost</div>
    <div className="flex items-center bg-[#03897B] text-white font-bold text-[32px] h-[100px] rounded-t-lg px-6">Total cost</div>

  </div>

  {/* Data Rows */}
  <div className="space-y-4 mt-4">
    {data1.map((item, index) => (
      <div
        key={index}
        className="grid grid-cols-[2fr_1fr_1fr_1fr] gap-x-2"
      >
        <div className="flex items-center bg-[#E7EBEB] text-black text-[32px] h-[100px] rounded-lg px-6">
          {item.type}
        </div>
        <div className="flex items-center bg-[#E7EBEB] text-black text-[32px] h-[100px] rounded-lg px-6">
          {item.description}
        </div>
        <div className="flex items-center bg-[#E7EBEB] text-black text-[32px] h-[100px] rounded-lg px-6">
          {item.example}
        </div>
        <div className="flex items-center bg-[#E7EBEB] text-black text-[32px] h-[100px] rounded-lg px-6">
          {item.example}
        </div>
      </div>
    ))}
  </div>
</div>
 <div className="text-[32px] text-black space-y-3 md:mt-5">
      {/* Section Title */}
      <h2 className="font-bold">Section 3: Basic Farm Record-Keeping</h2>

      {/* 3.1 */}
      <div>
        <h3 className="font-bold">3.1 Importance of Records:</h3>
        <ul className="list-disc ml-14 mt-2 space-y-1">
          <li>Track profits and losses</li>
          <li>Identify trends and problems</li>
          <li>Easier loan and grant applications</li>
        </ul>
      </div>

      {/* 3.2 */}
      <div>
        <h3 className="font-bold">3.2 Types of Records:</h3>
        <ul className="list-disc ml-14 mt-2 space-y-1">
          <li>Input records</li>
          <li>Production records</li>
          <li>Sales/Income records</li>
          <li>Expense records</li>
          <li>Activities &amp; Exercises:</li>
        </ul>
      </div>

      {/* Activities & Exercises */}
      <div>
        <h3 className="font-normal">Activities & Exercises:</h3>
        <ol className="list-decimal ml-14 mt-2 space-y-1">
          <li>Group discussion: "Why do some farmers succeed and others fail?"</li>
          <li>Practical exercise: Develop a simple business plan for a one-acre vegetable farm.</li>
          <li>Fill out a sample farm record sheet (provided by the trainer).</li>
        </ol>
      </div>
    </div>
    
        </div>
  )
}

export default EnterPriseDevelopment